import { blue, green, orange, purple, red, yellow, gray } from "@ant-design/colors";

import i18n from "../translations/i18n";

export const GetEnumByValue = (enumObj, value) => {
    if (value === null || value === undefined) return null;
    const expected = Object.entries(enumObj).find(([_, obj]) => obj.value === value);
    return expected ? expected[1] : null;
};

export const FileDownloadTypeEnum = {
    DOCUMENT: { value: "document" },
    CSV: { value: "csv" },
    ZIP: { value: "zip" },
    OTHER: { value: "other" },
};

export const StaticFolderEnum = {
    ROOT_FOLDER: { key: "0", id: -1 },
    SHARED_FOLDER: { key: "1", id: -2 },
    SEARCH_RESULT: { key: "2", id: 0 },
    TICKETS: { key: "3", id: -3 },
};

export const DocumentSignFlowEnum = {
    MYSELF: { value: "me" },
    REMOTE: { value: "other" },
    BY_LEGALE_USER: { value: "legale" },
    BY_MOBILE_DEVICE: { value: "mobile" },
    APPROVE: { value: "approve" },
    ON_SIGNING_PORTAL: { value: "signing_portal" },
    DYNAMIC_SIGNER: { value: "dynamic_signer" },
};

export const DocumentSignStatusEnum = {
    NOT_SIGNED: { value: 0, label: "signStatusNotSigned" },
    SIGNED: { value: 1, label: "signStatusSigned" },
    REJECTED: { value: 2, label: "signStatusRejected" },
    READY_TO_SIGN: { value: 3, label: "signStatusReadyToSign" },
    WAITING_FOR_REVIEW: { value: 4, label: "signStatusWaitingForReview" },
};
export const DocumentSignStatusObject = {
    0: "signStatusNotSigned",
    1: "signStatusSigned",
    2: "signStatusRejected",
    3: "signStatusReadyToSign",
    4: "signStatusWaitingForReview",
};
export const DocumentSignStatusColorObject = {
    0: {color: blue.primary, label: "signStatusNotSigned"},
    1: {color: green.primary, label: "signStatusSigned"},
    2: {color: red.primary, label: "signStatusRejected"},
    3: {color: orange.primary, label: "signStatusReadyToSign"},
    4: {color: purple.primary, label: "signStatusWaitingForReview"},
};

export const DocumentSignFlowStatusEnum = {
    NOT_SIGNED: { value: 0 },
    SIGNING: { value: 1 },
    SIGNED: { value: 2 },
    REJECTED: { value: 3 },
    PAUSED: { value: 4 },
    IN_BACKGROUND_PROCESS: { value: 5 },
};

export const DocumentSignMethodEnum = {
    REMOTE_SMS: { value: "sms" },
    REMOTE_NO_SMS: { value: "no_sms" },
    REMOTE_STAMP: { value: "email_pin" },
    CLOUD_CERTIFICATE: { value: "certification" },
    LOCAL_CERTIFICATE: { value: "local_certificate" },
    MOBILE_DEVICE: { value: "tablet_sign" },
    APPROVE_REMOTE: { value: "approve" },
    APPROVE_LEGALE: { value: "approve_legale" },
    APPROVE_API: { value: "approve_api" },
    SIGNING_PORTAL: { value: "signing_portal" },
    FEA: { value: "fea" },

    BULK_SIGN: { value: "bulk_sign" },
    LEGALE_USER_DEFINE: { value: "no_certification" },
    SIGNBOX: { value: "signbox" },
};

export const TicketStatusEnum = {
    OPEN: { value: "open", get label() { return i18n.t("open"); }, color: blue.primary },
    IN_PROGRESS: { value: "in_progress", get label() { return i18n.t("inProgress"); }, color: purple.primary },
    RESOLVED: { value: "resolved", get label() { return i18n.t("resolved"); }, color: green.primary },
    CLOSED: { value: "closed", get label() { return i18n.t("closed"); }, color: gray.primary },
};

export const TicketPriorityEnum = {
    LOW: { value: 1, get label() { return i18n.t("low"); }, color: purple.primary },
    MEDIUM: { value: 2, get label() { return i18n.t("medium"); }, color: yellow.primary },
    HIGH: { value: 3, get label() { return i18n.t("high"); }, color: orange.primary },
    URGENT: { value: 4, get label() { return i18n.t("urgent"); }, color: red.primary },
};

export const SocketReadyStatusEnum = {
    CONNECTING: 0,
    CONNECTED: 1,
    CLOSING: 2,
    CLOSED: 3,
};

export const SocketReadyStateObj = {
    0: "Connecting",
    1: "Connected",
    2: "Closing",
    3: "Closed",
};

export const ExcelReportStatusEnum = {
    INITIATED: { value: 1, get label() { return i18n.t("inProcess"); } },
    IN_PROCESS: { value: 2, get label() { return i18n.t("inProcess"); } },
    FINISHED: { value: 3, get label() { return i18n.t("finished"); } },
    FAILED: { value: 4, get label() { return i18n.t("failed"); } },
    STOPPED: { value: 5, get label() { return i18n.t("stopped"); } },
};

export const BulkSignStatusEnum = {
    0: "bulk_sign_item_status_update",
    1: "bulk_sign_status_update"
}

export const DocumentSignMethodDetailEnum = {
    REMOTE_SMS: {
        value: "sms",
        get label() { return i18n.t("productName_sms"); },
        is_remote: true,
        is_legale: false,
        is_automation: true,
        is_signature_position: true,
    },
    REMOTE_NO_SMS: {
        value: "no_sms",
        get label() { return i18n.t("productName_no_sms"); },
        is_remote: true,
        is_legale: false,
        is_automation: true,
        is_signature_position: true,
    },
    REMOTE_STAMP: {
        value: "email_pin",
        get label() { return i18n.t("productName_email_pin"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: true,
    },
    CLOUD_CERTIFICATE: {
        value: "certification",
        get label() { return i18n.t("productName_certification"); },
        is_remote: false,
        is_legale: true,
        is_automation: true,
        is_signature_position: true,
    },
    LOCAL_CERTIFICATE: {
        value: "local_certificate",
        get label() { return i18n.t("productName_local_certificate"); },
        is_remote: false,
        is_legale: true,
        is_automation: true,
        is_signature_position: true,
    },
    MOBILE_DEVICE: {
        value: "tablet_sign",
        get label() { return i18n.t("productName_tablet_sign"); },
        is_remote: false,
        is_legale: false,
        is_automation: true,
        is_signature_position: true,
    },
    APPROVE_REMOTE: {
        value: "approve",
        get label() { return i18n.t("productName_approve"); },
        is_remote: false,
        is_legale: false,
        is_automation: true,
        is_signature_position: false,
    },
    APPROVE_LEGALE: {
        value: "approve_legale",
        get label() { return i18n.t("productName_approve_legale"); },
        is_remote: false,
        is_legale: true,
        is_automation: true,
        is_signature_position: false,
    },
    APPROVE_API: {
        value: "approve_api",
        get label() { return i18n.t("productName_approve_api"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: false,
    },
    SIGNING_PORTAL: {
        value: "signing_portal",
        get label() { return i18n.t("productName_signing_portal"); },
        is_remote: false,
        is_legale: false,
        is_automation: true,
        is_signature_position: true,
    },
    SEND_EMAIL: {
        value: "send_email",
        get label() { return i18n.t("productName_send_email"); },
        is_remote: false,
        is_legale: false,
        is_automation: true,
        is_signature_position: false,
    },
    FEA: {
        value: "fea",
        get label() { return i18n.t("productName_fea"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: true,
    },

    BULK_SIGN: {
        value: "bulk_sign",
        get label() { return i18n.t("productName_bulk_sign"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: true,
    },
    SIGNBOX: {
        value: "signbox",
        get label() { return i18n.t("productName_signbox"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: true,
    },
    LEGALE_USER_DEFINE: {
        value: "no_certification",
        get label() { return i18n.t("productName_no_certification"); },
        is_remote: false,
        is_legale: true,
        is_automation: false,
        is_signature_position: true,
    },
    STAMP: {
        value: "stamp",
        get label() { return i18n.t("productName_stamp"); },
        is_remote: false,
        is_legale: false,
        is_automation: false,
        is_signature_position: false,
    },
};

export const SmartDocumentItemTypeEnum = {
    TEXT: {
        value: "text",
        label: "text",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    SELECT: {
        value: "select",
        label: "fieldType_select",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    NUMBER: {
        value: "number",
        label: "number",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    DATE: {
        value: "date",
        label: "date",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    TIME: {
        value: "time",
        label: "time",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    BOOLEAN: {
        value: "boolean",
        label: "yesNo",
        visible: false,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: true,
    },
    CURRENT_DATE: {
        value: "current_date",
        label: "currentDate",
        visible: false,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    PARAGRAPH: {
        value: "paragraph",
        label: "paragraph",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    CONDITIONAL_WORD: {
        value: "conditional_word",
        label: "conditionalWord",
        visible: true,
        is_conditional: true,
        is_condition_value: false,
        is_groupable: false,
    },
    CONDITIONAL_PARAGRAPH: {
        value: "conditional_paragraph",
        label: "conditionalParagraph",
        visible: true,
        is_conditional: true,
        is_condition_value: false,
        is_groupable: false,
    },
    MULTIPLE_CONDITIONAL_PARAGRAPH: {
        value: "multiple_conditional_paragraph",
        label: "multipleConditionalParagraph",
        visible: true,
        is_conditional: true,
        is_condition_value: false,
        is_groupable: false,
    },
    IMAGE: {
        value: "image",
        label: "takePhoto",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    CONDITIONAL_IMAGE: {
        value: "conditional_image",
        label: "conditionalImage",
        visible: true,
        is_conditional: true,
        is_condition_value: false,
        is_groupable: false,
    },
    ANSWER_SELECTION: {
        value: "answer_selection",
        label: "answerSelection",
        visible: false,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    ANSWER_SUMMARY: {
        value: "answer_summary",
        label: "answerSummary",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    ATTACHED_FILE: {
        value: "attached_file",
        label: "attachedFile",
        visible: true,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: true,
    },
    TITLE: {
        value: "title",
        label: "title",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    LINK: {
        value: "link",
        label: "link",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    IMAGE_PREVIEW: {
        value: "image_preview",
        label: "image",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    GUID: {
        value: "guid",
        label: "GUID",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    LEGALE_USER_NAME: {
        value: "legale_user_name",
        label: "userName",
        visible: false,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    LEGALE_USER_NICKNAME: {
        value: "legale_user_nickname",
        label: "origin",
        visible: false,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    LEGALE_USER_ID_NUMBER: {
        value: "legale_user_id_number",
        label: "idNumber",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    FOLIO: {
        value: "folio",
        label: "Folio",
        visible: true,
        is_conditional: false,
        is_condition_value: true,
        is_groupable: false,
    },
    DOCUMENT_COMPLIANCE: {
        value: "document_compliance",
        label: "documentCompliance",
        visible: true,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
    ITEM_GROUP: {
        value: "item_group",
        label: "itemGroup",
        visible: false,
        is_conditional: false,
        is_condition_value: false,
        is_groupable: false,
    },
};